import React from 'react';
import PropTypes from 'prop-types';
import {
  BackTop,
  Icon,
} from 'antd';

import styles from './BackButton.module.css';

const BackButton = ({ visibilityHeight }) => (
  <BackTop
    className={styles['ant-back-top']}
    visibilityHeight={visibilityHeight}
  >
    <div className={styles['ant-back-top-inner']}>
      <Icon type="up" />
    </div>
  </BackTop>
);

BackButton.propTypes = {
  visibilityHeight: PropTypes.number.isRequired,
};

export default BackButton;
